import React from 'react';
// 自己写的
import ComparisonCard from '../../components/ComparisonCard';

import '@/pages/opinion/assets/scss/pages/competitor/comparisonOverview.scss';

const ComparisonOverview = ({ filter, gameInfo, translateTopicFunc }: any) => {
  return (
    <div className="dbo-comparison-overview">
      <ComparisonCard
        filter={filter}
        gameInfo={gameInfo}
        translateTopicFunc={translateTopicFunc}
      />
    </div>
  );
};

export default ComparisonOverview;
